import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';

export default {
	setBookingHistoryAddress({ commit }, data) {
        commit('SET_BOOKING_HISTORY_ADDRESS', data);
    },
    getWoStatusRank({ }, payload) {
        return axios.get(process.env.MIX_API_URL + 'cms/booking-setting/wo-status-rank')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                return data
            })
            .catch(() => console.log('Error when get woo status rank from api'));
    },
}